import axios from 'api/config'
import { trackEvent } from 'api/analytics'
import { memoize } from 'utils/memoize'

const getUserInfoData = () => axios.get('/api/current_user').catch(() => null)

const getUserInfo = memoize(getUserInfoData)

export { getUserInfo, trackEvent }
